module.exports = __webpack_public_path__ + "img/legume-black-eyed-peas-190x100.1555688a.jpg";